"use client"

import React, { useEffect } from "react"
import { motion, useAnimation, useInView } from "framer-motion"
import { services } from "@/services/start/getServices.js"

const ServiceCard = ({ service, index }) => {
  const controls = useAnimation()
  const ref = React.useRef(null)
  const inView = useInView(ref, { once: true })

  useEffect(() => {
    if (inView) {
      controls.start("visible")
    }
  }, [controls, inView])

  return (
    <motion.div
      ref={ref}
      className="bg-gradient-to-br from-white to-gray-50 rounded-2xl shadow-lg overflow-hidden transform transition-all duration-300 hover:shadow-2xl hover:scale-105 border border-gray-100"
      initial="hidden"
      animate={controls}
      variants={{
        hidden: { opacity: 0, y: 50 },
        visible: {
          opacity: 1,
          y: 0,
          transition: { duration: 0.6, delay: index * 0.2 },
        },
      }}
    >
      <div className="relative p-8">
        {/* Decorative element */}
        <div className="absolute top-0 right-0 w-24 h-24 bg-[var(--gold)] opacity-5 rounded-bl-full" />

        <div className="relative">
          <motion.div
            className="flex items-center justify-center w-20 h-20 rounded-full bg-[var(--gold)]/10 text-[var(--gold)] mb-6"
            initial={{ scale: 0, rotate: -10 }}
            animate={{ scale: 1, rotate: 0 }}
            transition={{ delay: 0.2 + index * 0.2, type: "spring", stiffness: 260, damping: 20 }}
          >
            <span className="text-5xl">{service.icon}</span>
          </motion.div>

          <h3 className="text-2xl font-bold mb-3 text-gray-800">{service.title}</h3>

          <div className="w-12 h-1 bg-[var(--gold)] mb-4 rounded-full" />

          <p className="text-gray-600 leading-relaxed mb-8">{service.description}</p>

          <motion.button
            className="bg-[var(--gold)] border border-[var(--gold)] text-white px-6 py-3 rounded-lg font-semibold text-sm transition-colors duration-300 hover:bg-transparent hover:text-[var(--gold)] flex items-center gap-2 group"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Más Información
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </motion.button>
        </div>
      </div>
    </motion.div>
  )
}

function Services() {
  const controls = useAnimation()
  const ref = React.useRef(null)
  const inView = useInView(ref, { once: true })

  useEffect(() => {
    if (inView) {
      controls.start("visible")
    }
  }, [controls, inView])

  return (
    <section ref={ref} className="py-24 bg-transparent overflow-hidden">
      <div className="container mx-auto px-4">
        <motion.div
          className="text-center mb-20"
          initial="hidden"
          animate={controls}
          variants={{
            hidden: { opacity: 0, y: -20 },
            visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
          }}
        >
          <span className="text-[var(--gold)] font-medium mb-2 inline-block">SERVICIOS PROFESIONALES</span>
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-gray-800">Nuestros Servicios</h2>
          <motion.div
            className="w-24 h-1 bg-[var(--gold)] mx-auto mb-8 rounded-full"
            initial={{ scaleX: 0 }}
            animate={controls}
            variants={{
              hidden: { scaleX: 0 },
              visible: { scaleX: 1, transition: { duration: 0.6, delay: 0.3 } },
            }}
          />
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Ofrecemos una amplia gama de servicios legales para satisfacer todas sus necesidades jurídicas con
            profesionalismo y excelencia.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <ServiceCard key={index} service={service} index={index} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default Services

